import React from 'react';
import PropTypes from 'prop-types';

const IconEmbed = props => {
  const { height, width, className } = props;

  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 40 32"
    >
      <title>Embed icon</title>
      <path d="M26 23l3 3 10-10-10-10-3 3 7 7z" />
      <path d="M14 9l-3-3-10 10 10 10 3-3-7-7z" />
      <path d="M21.916 4.704l2.171 0.592-6 22.001-2.171-0.592 6-22.001z" />
    </svg>
  );
};

IconEmbed.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

IconEmbed.defaultProps = {
  height: 32,
  width: 32,
  className: '',
};

export default IconEmbed;



// WEBPACK FOOTER //
// ./src/components/Icon/svg/Embed.js